import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="40" viewBox="0 0 66 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66 40H0V-3.8147e-06H66V40Z" fill="#CE1126" />
    <path
      d="M0 40H16.5L26.4 36L16.5 32L26.4 28L16.5 24L26.4 20L16.5 16L26.4 12L16.5 8L26.4 4L16.5 -2.08616e-06H0V40Z"
      fill="white"
    />
    <path
      d="M0.0210876 39.9887V0.00503455H65.9835V39.9887H0.0210876ZM0.845618 39.1557H65.159V0.838026H0.845618V39.1557Z"
      fill="#9F9D9D"
    />
  </svg>
)
